import { useIntl } from "react-intl";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { SerializedError } from "@reduxjs/toolkit";
import {
  instanceOfFetchBaseQueryError,
  instanceOfFetchSerializedError,
} from "@/interfaces/CheckType";
import ResponseCode from "@/enums/ResponseCode";

const useMessage = () => {

  const { formatMessage } = useIntl();


  const ResponseMessage = (code: number = -1, message: string = "") => {
    let info = "";
    switch (code) {
      case ResponseCode.FAILED_LOGIN_RESPONSE:
        info = formatMessage({ id: "response_login_failed" });
        break;
      case ResponseCode.UNAUTHORIZED:
        info = formatMessage({ id: "response_unauthorized_failed" });
        break;
      default:
        info = formatMessage({ id: "response_server_no_response" });
        break;
    }
    return info;
  };

  const message = (
    data: number | FetchBaseQueryError | SerializedError | undefined
  ) => {
    let hint = "";

    if (typeof data === "number") {
      hint = ResponseMessage(data);
    } else if (instanceOfFetchBaseQueryError(data)) {
      if (data && data.status === "CUSTOM_ERROR") {
        hint = ResponseMessage(data.data as number, data.error as string);
      } else {
        hint = ResponseMessage();
      }
    } else if (instanceOfFetchSerializedError(data)) {
      console.log(`useErrorMessage SerializedError : `, data);
    }
    return hint;
  };

  return { message, formatMessage };
};

export default useMessage;
